export default function (arr, newKey) {
	return arr.reduce((result, item) => {
		return { ...result, [item[newKey]]: item };
	}, {});
}
